import React, { forwardRef } from 'react';
import { useLoadedImg } from '../../hooks/useLoadedImg';
import { formatNameToFirstLetters } from './utils';
import { Wrapper, AvatarImage, Fallback } from './styled';
/**
 *  * Avatar component that displays a user's profile picture.
 * @typedef {Object} IAvatarProps - Interface representing the properties for the Avatar component.
 * @property {string} name - The initials of the name to be displayed in the Avatar.
 * @property {string | undefined} [src] - The source URL for the avatar image.
 * @property {'rounded' | 'square' | undefined} [variant = 'rounded'] - The variant of the avatar shape. Optional: Can be 'rounded' for a rounded avatar or 'square' for a square avatar.
 * @property {string} [className] - CSS string to override component styles.
 */
const Avatar = forwardRef(function Avatar({ name, src, variant = 'rounded', ...rest }, ref) {
    const loadedState = useLoadedImg(src);
    const isLoaded = loadedState === 'loaded';
    return (React.createElement(Wrapper, { ref: ref, "$variant": variant, ...rest },
        React.createElement(AvatarImage, { "$isLoaded": isLoaded, src: src, alt: name }),
        !isLoaded ? React.createElement(Fallback, null, formatNameToFirstLetters(name)) : null));
});
export default Avatar;
